module.exports = __webpack_public_path__ + "static/media/micard.b328cc8f.png";